<template>
  <v-container fluid>
    <v-row dense>
      <v-col>
        <MediaFilePickerForm
          :count="value.length"
          :file-type="filters.type"
          :file-type-disabled="fileType.value !== $options.mediaTypesKeys.ALL"
          :filters="filters"
          @change-filters="updateFilters"
          @sort="sortFiles(value)"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-row>
          <v-col>
            <v-row>
              <v-progress-linear
                v-if="$apollo.queries.files.loading"
                indeterminate
                color="primary"
              />
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <MediaFilePreview
            v-for="file in files"
            :key="file.id"
            picker-mode
            description
            :value="file"
            :is-chosen="value.includes(file.id)"
            @change="updateFiles"
          />
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-pagination
          v-if="paginationLength > 1"
          dense
          :length="paginationLength"
          v-model="page"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MediaFilePickerForm from './media-file-picker-form'
import MediaFilePreview from '@/components/media-file-preview'
import filesQuery from '@/services/gql/types/Files/queries/files.gql'
import { mediaTypesKeys } from '@/configs/mediaFileTypes'
export default {
  name: 'MediaLibraryFilePicker',
  mediaTypesKeys: mediaTypesKeys(),
  components: {
    MediaFilePickerForm,
    MediaFilePreview
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    fileType: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      files: [],
      filesTotalCount: 0,
      page: 1,
      limit: 12,
      filters: {
        fileName: null,
        selected: null,
        type: this.fileType.value,
        sort: 'createdAt_DESC',
        autoSort: false,
        hideSelected: false
      }
    }
  },
  watch: {
    filters: {
      handler () {
        this.page = 1
      },
      deep: true
    },
    value (newVal) {
      if (!newVal.length) return
      this.sortFiles(newVal)
    }
  },
  computed: {
    filesWhereInput () {
      const where = {}
      const order = { orderBy: 'createdAt_DESC' }
      if (this.filters.fileName) where.fileName_contains = this.filters.fileName
      if (this.filters.selected) where.id_in = this.value
      if (this.filters.hideSelected) where.id_not_in = this.value
      if (this.filters.type) {
        where.type = this.filters.type === 'ALL'
          ? undefined
          : this.filters.type.toUpperCase()
      }
      if (this.filters.sort) order.orderBy = this.filters.sort
      return {
        where,
        ...order,
        skip: ((this.page || 1) - 1) * this.limit,
        limit: this.limit
      }
    },
    paginationLength () {
      if (!this.filesTotalCount) return 0
      return Math.ceil(this.filesTotalCount / this.limit)
    }
  },
  methods: {
    updateFilters ({ field, value }) {
      if (this.filters[field] === undefined) return
      this.filters[field] = value
    },
    sortFiles (value) {
      if (!this.filters.autoSort) return
      // sort all items based on chosen items
      this.files.sort((a, b) => value.includes(b.id) - value.includes(a.id))
    },
    updateFiles (files) {
      this.$emit('change', files)
    }
  },
  apollo: {
    files: {
      query: filesQuery,
      fetchPolicy: 'network-only',
      variables () {
        return this.filesWhereInput
      },
      result ({ data }) {
        const value = data?.files?.list
        this.files = value
        this.filesTotalCount = data?.files?.totalCount
        this.sortFiles(value)
      }
    }
  },
  mounted () {
    this.sortFiles(this.value)
  }
}
</script>
